import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { useRouter } from "next/router";
import ButtonGroup from "components/Reusables/ButtonGroup";

function BackButton(props) {
	const router = useRouter();
	return (
		<ButtonGroup
			alignButtons={"start"}
			onClick={() => router.back()}
			btn1={{
				text: (
					<>
						<FontAwesomeIcon icon={faArrowLeft} className="w-20px me-2 inline-flex" /> {` Back`}
					</>
				),
			}}
		>
			<a aria-label="back-to-products" className="btn btn-primary-dark">
				Back To All Products
			</a>
		</ButtonGroup>
	);
}

export default BackButton;
